import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	card: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: token('elevation.surface.raised'),
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderRadius: token('radius.small'),
		boxShadow: token('elevation.shadow.raised'),
		gap: token('space.150'),
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: token('space.100'),
	},
});

export const CreateProjectProgressUpdateActionSkeleton = (): React.JSX.Element => {
	return (
		<Stack xcss={styles.card} testId="project-status-update-action-renderer.ui.skeleton">
			{/* Header: project key and status/date */}
			<Inline>
				<Skeleton width="100%" height="30px" />
			</Inline>
			{/* Body: status, target date, summary */}
			<Inline>
				<Skeleton width="100%" height="80px" />
			</Inline>
			{/* Footer: buttons */}
			<Inline xcss={styles.footer}>
				<Skeleton width="80px" height="32px" />
				<Skeleton width="100px" height="32px" />
			</Inline>
		</Stack>
	);
};
